import Vue from "vue";

export default {
  /**
   * 班级下的学生信息接口
   * @param params gardenId=&classId=
   * @param config
   * @returns {Promise<AxiosResponse<T>>}
   */
  async getClassStudents(params = {}, config = {}) {
    config.params = params;
    const result = await Vue.http.get(
      "/lw-garden-server/student/class/students",
      config
    );
    return result;
  },
};
